import { render } from "./TabContainer.vue?vue&type=template&id=221b5248&scoped=true"
import script from "./TabContainer.vue?vue&type=script&lang=js"
export * from "./TabContainer.vue?vue&type=script&lang=js"

import "./TabContainer.vue?vue&type=style&index=0&id=221b5248&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221b5248"]])

export default __exports__